import router from '@/router/router'
import nativeCom from '@/utils/modules/utils.native.common.js';
// import utils from '@/utils/utils';
import api from '@/api/api'
import store from '@/store/store'

export default {
  inbound: {
		duplicate: {
			time: 0,
			enable: true
		},
		routerLink: function(option) {
			router.push(option).catch(function() {});
		},
		sendChildData: function(jsonString) {
			var child = JSON.parse(jsonString);
			window.app.$root.$store.commit("SET_UI_CHILD", child);
		},
		callMnChk: function(nativeLog) {
			var that = this;
			// var currentTime = new Date().getTime();
			// var storedTime = this.duplicate.time;
			// this.duplicate.time = currentTime;
			// var timeGap = currentTime - storedTime;
			// if(timeGap <= 2000) {
			// 	return;
			// }

			if(!this.duplicate.enable) {
				return;
			}
			this.duplicate.enable = false;
			
			// var strLocation = "";
			// try {
			// 		if(store.state.ui.child.name == 'native-location') {
			// 				strLocation = btoa(unescape(encodeURIComponent(JSON.stringify(store.state.ui.child.data))));
			// 		}
			// } catch(err) {
			// 		alert(err);
			// 		console.log(err)
			// }
			
			var param = {
				nativeLog : nativeLog,
				userAgent: window.navigator.userAgent,
				// location: strLocation,
				// currentTime: currentTime,
				// storedTime: storedTime,
				// timeGap: timeGap
			};
			api.beacon.getMacAddress(param)
        .then(function(data) {
          console.log("utils.native.interface.js <api.beacon.getMacAddress.response>", data);
					var list = [];
					for(var item of data) {
						list.push(item.macAddress);
					}
					
					var macAddresses = {
						type: "A",
						list: list
					}
					
					var jsonString = JSON.stringify(macAddresses);
					window.app.$root.$utils.nativeIf.outbound.callbackMnChk(jsonString);
					
					setTimeout(function(){that.duplicate.enable = true;}, 2000);
        })
        .catch(function(error) {
          console.log(error.rtMsg);
					that.duplicate.enable = true;
        });
		},
		movePage: function(type) {
			if(type == 'HOME') {
				router.push({ name: "main" }).catch(function() {});
			} else if(type == 'MY_CSTMR') { // 내고객
				router.push({ name: "myCstmr-list" }).catch(function() {});
			} else if(type == 'MY_CSTMR_REG') { // 내고객 등록
				router.push({ name: "myCstmr-reg" }).catch(function() {});
			} else if(type == 'EDU_PLAN_MAP') { // 에듀플랜맵
				alert("TODO:에듀플랜맵 설정 필요 함");
			} else if(type == 'MY_PAGE') { // 마이페이지
				var orgnzPstn = store.getters.orgnzPstn;
				if(orgnzPstn === 'COG01') {
					alert("TODO:지국장");
				} else {
					alert("TODO:기타");
				}
			} else {
				router.push({ name: "main" }).catch(function() {});
			}
		},
		sessionExpired: function() {
			this.$store.dispatch("clearUser");
      this.$utils.nativeIf.outbound.sessionExpired();
		},
		getAppDb: function(key, value) {
			var appdb = {};
			appdb.key = key;
			appdb.value = value;
			store.commit("SET_UI_APPDB", appdb);
		},
		getLocation: function(value) {
			// 배명훈, 2021.11.10, 주소정보 조회 IF
			var data = JSON.parse(value);
			var child = {
        name: 'native-location',
        data: data
      };
			store.commit("SET_UI_CHILD", child);
		},
		eduAtndnCheck: function(value) {
			// QR교육출격 스캔 값 콜백 함수
			if(value === 'cancel') {
				return;
			}
			
			var param = {};
			param.qrScan = value
			api.eduqr.atnd(param)
        .then(function(data) {
					alert(data.message + '\n' + 'Time ' + data.datetime)
        })
        .catch(function(error) {
          alert(error.rtMsg);
        });
		}
	},                                                                                      
	outbound: {
		// duplicate: {
		// 	time: 0,
		// 	enable: true
		// },
		outlink: function(url) {
			if (nativeCom.isAndroid()) {
        // eslint-disable-next-line no-undef
				Android.outlink(url);
			} else if (nativeCom.isIos()) {
				var iosWebkit = nativeCom.getWebkit();
				iosWebkit.messageHandlers.outlink.postMessage(url);
			} else {
				// var windowName = "newWindow" + nativeCom.guid();
				window.open(url);
			}
		},
    outlinkWithUserInfo: function(url) {
      api.dashboard
        .getUserInfo()
        .then(function (res) {
            var urlWithUserInfo = url.replace(/\${userId}/gi, res.userId);
            window.app.$root.$utils.nativeIf.outbound.outlink(urlWithUserInfo)
        })
        .catch(function (error) {
          alert(error.rtMsg);            
        });
		},
		newPage: function (url) {
			if (nativeCom.isAndroid()) {
        // eslint-disable-next-line no-undef
				Android.newPage(url);
			} else if (nativeCom.isIos()) {
				// window.webkit.messageHandlers.newPage.postMessage(url);
				var iosName = "iosName" + nativeCom.guid();
				window.open(url, iosName, "height=700,width=500,scrollbar=yes,menubar=yes");
			} else {
				// var windowName = "newWindow" + nativeCom.guid();
				// window.open(url, windowName, "height=700,width=500,scrollbar=yes,menubar=yes");
				window.open(url);
			}
		},
		close: function (flag=false) {
			if (nativeCom.isAndroid()) {
				// eslint-disable-next-line no-undef
				Android.close(flag);
			} 
			// else if (nativeCom.isIos()) {
			// 	var param={};
			// 	param.flag = flag;
			// 	var jsonString = JSON.stringify(param);
			// 	window.webkit.messageHandlers.close.postMessage(jsonString);
			// } 
			else {
				if(flag) {
					window.opener.app.$root.$router.go(window.opener.app.$root.$router.currentRoute);
				}

				window.open('', '_self').close();
			}
		}, 
		sendChildData: function(child) {
			var jsonString = JSON.stringify(child);
			if (nativeCom.isAndroid()) {
				// eslint-disable-next-line no-undef
				Android.sendChildData(jsonString);
			} 
			// else if (nativeCom.isIos()) {
			// 	window.webkit.messageHandlers.sendChildData.postMessage(jsonString);
			// } 
			else {
				window.opener.app.$root.$store.commit("SET_UI_CHILD", child);
				window.app.$root.$utils.nativeIf.outbound.close(false);
			}
		},
		setAppDB: function (key, value) {
			if (nativeCom.isAndroid()) {
				// eslint-disable-next-line no-undef
				Android.setAppDB(key, value);
			} else if (nativeCom.isIos()) {
				var data = {};
        data.key = key;
        data.value = value;
				var jsonString = JSON.stringify(data);
				var iosWebkit = nativeCom.getWebkit();
				iosWebkit.messageHandlers.setAppDB.postMessage(jsonString);
			} 
		},
		getAppDB: function (key) {
			var callbck = "window.app.$root.$utils.nativeIf.inbound.getAppDb";
			if (nativeCom.isAndroid()) {
				// eslint-disable-next-line no-undef
				Android.getAppDB(key, callbck);
			} else if (nativeCom.isIos()) {
				var data = {};
        data.key = key;
        data.callback = callbck;
				var jsonString = JSON.stringify(data);
				var iosWebkit = nativeCom.getWebkit();
				iosWebkit.messageHandlers.getAppDB.postMessage(jsonString);
			} 
		},
		callbackMnChk: function(jsonString) {
			if (nativeCom.isAndroid()) {
				// eslint-disable-next-line no-undef
				Android.callbackMnChk(jsonString);
			} else if (nativeCom.isIos()) {
				var iosWebkit = nativeCom.getWebkit();
				iosWebkit.messageHandlers.callbackMnChk.postMessage(jsonString);
			} 
		},
		sessionExpired: function() {
			if (nativeCom.isAndroid()) {
				// eslint-disable-next-line no-undef
				Android.sessionExpired();
			} else if (nativeCom.isIos()) {
				var iosWebkit = nativeCom.getWebkit();
				iosWebkit.messageHandlers.sessionExpired.postMessage('');
			} else {
				router.push({name:'login'}).catch(function() {});
			}
		},
		userMnChk: function (jsonString) {
			/**
			 * jsonString : 맥어드래스 
			 */
			if (nativeCom.isAndroid()) {
				// eslint-disable-next-line no-undef
				Android.userMnChk(jsonString);
			} else if (nativeCom.isIos()) {
				var iosWebkit = nativeCom.getWebkit();
				iosWebkit.messageHandlers.userMnChk.postMessage(jsonString);
			} 
		},
		beaconLeaveChk: function (jsonString) {
			/**
			 * jsonString : 맥어드래스 
			 */
			if (nativeCom.isAndroid()) {
				// eslint-disable-next-line no-undef
				Android.beaconLeaveChk(jsonString);
			} else if (nativeCom.isIos()) {
				var iosWebkit = nativeCom.getWebkit();
				iosWebkit.messageHandlers.beaconLeaveChk.postMessage(jsonString);
			} 
		},
		sendSMS: function (tel, msg) {
			if (nativeCom.isAndroid()) {
				// eslint-disable-next-line no-undef
				Android.sendSMS(tel, msg);
			} else if (nativeCom.isIos()) {
				var data = {};
        data.tel = tel;
        data.msg = msg;
				var jsonString = JSON.stringify(data);
				var iosWebkit = nativeCom.getWebkit();
				iosWebkit.messageHandlers.sendSMS.postMessage(jsonString);
			} 
		},
		routerAfterEach: function(pageName) {
			console.log("routerAfterEach =========> ", pageName)
			if (nativeCom.isIos()) {
				var iosWebkit = nativeCom.getWebkit();
				iosWebkit.messageHandlers.webViewChange.postMessage('');
				// iosWebkit.messageHandlers.webViewChange.postMessage(pageName);
			} 
		},
		appUpdate: function(url, apk, plist) {
			console.log(apk, plist);
			if (nativeCom.isAndroid()) {
        // eslint-disable-next-line no-undef
				// Android.appUpdate(url);

				// 2021.12.23, 배명훈, 자동업데이트 배포 후 해당 코드로 변경 필요 함
				// eslint-disable-next-line no-undef
				Android.appUpdate(url, apk);
			} else if (nativeCom.isIos()) {
				var iosWebkit = nativeCom.getWebkit();
				// 2021.12.23, 배명훈, 자동업데이트 배포 후 해당 코드로 변경 필요 함
				iosWebkit.messageHandlers.appUpdate.postMessage(plist);
			} 
		},
		getLocation: function () {
			// 배명훈, 2021.11.10, 주소정보 조회 IF
			var callback = "window.app.$root.$utils.nativeIf.inbound.getLocation";
			if (nativeCom.isAndroid()) {
				// eslint-disable-next-line no-undef
				Android.getLocation(callback);
			} else if (nativeCom.isIos()) {
				var iosWebkit = nativeCom.getWebkit();
				iosWebkit.messageHandlers.getLocation.postMessage(callback);
			} 
		},
		openQrScaner: function(callback) {
			// var that = this;
			// if(!this.duplicate.enable) {
			// 	return;
			// }
			// this.duplicate.enable = false;
			// setTimeout(function(){that.duplicate.enable = true;}, 3000);

			// QR스캐너 열기
			if (nativeCom.isAndroid()) {
				// eslint-disable-next-line no-undef
				Android.openQrScaner(callback);
			} else if (nativeCom.isIos()) {
				var iosWebkit = nativeCom.getWebkit();
				iosWebkit.messageHandlers.openQrScaner.postMessage(callback);
			} 
		}
	}
}

// var child = {
// 	name: 'pop-query-111111',
// 	data: {
// 	  id : 123,
// 	  title: '제목233332',
// 	  body: '본문11111'
// 	}
// }; 
// window.app.$root.$utils.nativeIf.inbound.sendChildData(child);